import axios from "axios";

const baseURL = process.env.VUE_APP_API_URL + '/wallet';

class MajorDonorsService {

  static buildApiUrlAndParams(
    url: string,
    params: Record<string, string | number | boolean | undefined | null> = {}
  ): { url: string } {
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (
        value !== undefined &&
        value !== null &&
        value.toString().trim() !== ""
      ) {
        queryParams.append(key, value.toString().trim());
      }
    });

    const queryString = queryParams.toString();
    return {
      url: queryString ? `${url}?${queryString}` : url,
    };
  }

  static getTransactions(query_params = { page: 1, ordering: '' }) {
    let url = `${baseURL}/major-donor-details/?page=${query_params.page || 1}`;
    if (query_params.ordering) {
      url += `&ordering=${query_params.ordering}`;
    }

    return axios.get(url);
  }

  static transferPayment(requestBody: any = {}) {
    let url = `${baseURL}/major-donor-transfer/`;

    return axios.post(url, requestBody);
  }

  static getDonationLogs(params = {}) {
    const { url } = this.buildApiUrlAndParams(`${baseURL}/major-donor-donation-logs/`, params);

    return axios.get(url);
  }

  static getDonationLogsDropdowns() {
    const  url  = `${baseURL}/major-donor-wallet-filters/`;

    return axios.get(url);
  }

}

export default MajorDonorsService;


